<style src="./css/login.css"></style>

<template>
	<div class="loginContainer circular">
		<div class="loginWrapper">
			<form class="login100-form validate-form">
				<span class="login100-form-logo">
					<img src="~@/assets/logo.jpeg" class="w-50" alt="logo">
				</span>

				<span class="login100-form-title py-5">
                    Zapomenuté heslo
				</span>

				<div class="wrap-input100 validate-input" data-validate="Zadejte email">
					<input class="input100" type="text" name="email" v-model="address" placeholder="@ Emailová adresa" autocomplete="off">
					<span class="focus-input100"></span>
				</div>

				<div class="container-login100-form-btn">
					<b-button variant="light" class="loginBtn" id="btnSendNewPassword" @click="sendNewPassword">Poslat nové heslo</b-button>
				</div>

				<div class="text-center">
					<router-link class="bottomText mr-3" id="backToLogin" to="/login">
						Zpět na přihlášení
					</router-link>
				</div>
			</form>
		</div>
		<div id="snackbar">{{msg}}</div>
	</div>
</template>

<script src="./js/login.js"></script>

<script>
	import AuthService from '@/services/AuthService.js';
	import dataService from '@/services/dataService.js';
	import vueFormHelper from '@/js/VueFormHelper.js';

    export default {
		  data() {
        return {
          address: '',
          msg: ''
        };
      },
        methods: {
          async sendNewPassword() {
            try {
              await dataService.sendEmail($EmailTypeGlobal.forgottenPassword, this.address);
              this.$router.push('/login');
            } catch (error) {
			  vueFormHelper.showSnackbarMessage(this, error.response.data.msg, document);
            }
          }
		}
    };
</script>

<style>
    #btnSendNewPassword {
        position: relative;
        top: 80px;
    }

    #backToLogin {
        position: relative;
        top: 108px;
        left: 0px;
    }
</style>